import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=edef54d0&"
import script from "./ContactsSection.vue?vue&type=script&lang=js&"
export * from "./ContactsSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports